import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Compact theme toggle button. Variant: "navbar" (lighter, for customer header)
 * or "admin" (denser, for admin topbar).
 */
const ThemeToggle = ({ variant = "navbar" }) => {
    const { resolved, toggle } = useTheme();
    const isDark = resolved === "dark";

    if (variant === "admin") {
        return (
            <button
                onClick={toggle}
                aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
                className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-600 transition-colors hover:border-brand-300 hover:text-brand-700 dark:border-white/10 dark:bg-zinc-900 dark:text-zinc-300 dark:hover:border-brand-400/40 dark:hover:text-brand-300"
                data-testid="theme-toggle-admin"
            >
                {isDark ? <Sun className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
            </button>
        );
    }

    return (
        <button
            onClick={toggle}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-zinc-700 hover:bg-brand-50 hover:text-brand-700 dark:text-zinc-300 dark:hover:bg-white/10 dark:hover:text-brand-300"
            data-testid="theme-toggle"
        >
            {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
    );
};

export default ThemeToggle;
